module.exports = __webpack_public_path__ + "img/stock4.1e765ef0.png";